
import { Vue } from "vue-class-component";

export default class Header extends Vue {
  get breadcrumbs(): any {
    return this.$route.meta.breadcrumbs;
  }
}
